import { useState } from 'react';

import useToggle from '@/data/hook/useToggle';
import { Nullable } from '@/models/Model';

export type AnswerMode = 'text' | 'media';

type UseAnswerModeArgs = {
  mediaFile?: Nullable<File | string>;
  initialEditing?: boolean;
};

export function useAnswerMode({
  mediaFile,
  initialEditing = false,
}: UseAnswerModeArgs) {
  const [mode, setMode] = useState<AnswerMode>(mediaFile ? 'media' : 'text');
  const {
    isOpen: isEditing,
    open: handleStartEdit,
    close: handleFinishEdit,
  } = useToggle(initialEditing);

  const handleSwitchToMedia = () => {
    setMode('media');
    handleStartEdit();
  };

  const handleSwitchToText = () => {
    setMode('text');
    handleStartEdit();
  };

  return {
    mode,
    isEditing,
    handleSwitchToMedia,
    handleSwitchToText,
    handleStartEdit,
    handleFinishEdit,
  };
}
